import Vue from 'vue';
import Router from 'vue-router';
import Start from './views/Start.vue';
// import CompanyBase from './views/CompanyInfoBase';
// import CompanyExtended from './views/CompanyExtended';

Vue.use(Router);

// TODO: если не приняты Правилами обработки персональных данных - со всех страниц редирект на Start

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'start',
      component: Start
    },
    {
      path: '/poll',
      name: 'poll',
      component: () => import('./views/Poll.vue')
    },
    {
      path: '/elements',
      name: 'elements',
      component: () => import('./views/Elements.vue')
    },
    {
      path: '/cancel',
      name: 'cancel',
      component: () => import('./views/Cancel')
    },
    {
      path: '/finish',
      name: 'finish',
      component: () => import('./views/Finish')
    }
  ]
})
